import { AuditFileList } from '@shared/components/FileList';
import { AuditImageList } from '@shared/components/ImageList';
import { View } from '@shared/components/View';
import { FileUpload } from '@shared/types/fieldValues';

interface Props {
  files: FileUpload[];
  editable: boolean;
  onFileRemoved?(file: FileUpload): void;
  maxWidth?: number;
  maxHeight?: number;
}

export function AuditFieldMedia({
  files,
  editable,
  onFileRemoved,
  maxWidth = 200,
  maxHeight = 133,
}: Props) {
  return (
    <View gap={0.5} padding={1}>
      <AuditImageList
        files={files}
        editable={editable}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        minWidth={100}
        onRemoved={onFileRemoved}
      />
      <AuditFileList files={files} editable={editable} onFileRemoved={onFileRemoved} />
    </View>
  );
}
